import { ComplaintsIndices } from './types';

export const emptyComplaintsIndices: ComplaintsIndices = Object.freeze({
  errors: [],
  warnings: [],
  byPriority: [],
});
